@if (displayIcon) {
  <mat-icon class="alert-icon" inline="true" fontSet="fontastic" [fontIcon]="alertIcon"></mat-icon>
}
<div class="alert-content">
  <ng-content></ng-content>
</div>
